import * as React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import ViewMode from './ViewMode'

import './ViewSelector.scss'

interface IProps {
  viewModes: ViewMode[]
  selectedViewMode: string
  selectViewMode: (mode: string) => void
  variant?: 'default' | 'grouped'
}

@observer
export default class ViewSelector extends React.Component<IProps> {
  public render() {
    const { viewModes, selectedViewMode, selectViewMode, variant } = this.props
    const isGrouped = variant === 'grouped'

    return (
      <div
        className={classList({
          'view-selector no-grow': true,
          'view-selector--grouped': isGrouped,
        })}
      >
        {viewModes.map((item, index) => (
          <div
            className={classList({
              'view-item': true,
              selected: selectedViewMode === item.mode,
              'inactive-element': item.isDisabled,
              'view-item--first': isGrouped && index === 0,
              'view-item--last': isGrouped && index === viewModes.length - 1,
            })}
            key={item.mode}
            onClick={selectViewMode.bind(this, item.mode)}
          >
            <item.Icon />
          </div>
        ))}
      </div>
    )
  }
}
